<template>
  <div class="my-2 d-flex">
    <p class="border p-1 text-center text-muted small flex-fill">
      {{ transformDate(selectedDate) }}
    </p>
    <b-button class="outline-main" @click="openCalendar" size="sm">
      <span class="material-icons align-middle smaller">event_note</span>
    </b-button>
    <care-calendar
      ref="calendar"
      :dates="Object.keys(getCriterionValues(this.currentChild))"
      :editableDates="getEditableDates"
      :availableDates="getAvailableDates(this.currentChild)"
      @change-date="handleChangeDate"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import { transformDate } from '@/utils/Dates.js';
import CareCalendar from '@/components/challenge/ChallengeCalendar.vue';

export default {
  components: {
    CareCalendar,
  },
  props: {
    currentChild: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      selectedDate: '',
    };
  },
  mounted() {
    const routeDate = this.$route.query.date;
    this.selectedDate = routeDate ? routeDate : this.defaultDateString();
  },
  computed: {
    ...mapGetters('challenge', ['getEditableDates', 'getAvailableDates', 'getCriterionValues']),
  },
  methods: {
    transformDate,
    handleChangeDate(date) {
      window.location.href = window.location.pathname + `?date=${date}`;
    },
    openCalendar() {
      this.$refs.calendar.openCalendar();
    },
    defaultDateString() {
      const today = new Date();
      return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(
        today.getDate(),
      ).padStart(2, '0')}`;
    },
  },
};
</script>
